import { render, staticRenderFns } from "./VetBackground.vue?vue&type=template&id=649a4ef2&scoped=true"
import script from "./VetBackground.vue?vue&type=script&lang=js"
export * from "./VetBackground.vue?vue&type=script&lang=js"
import style0 from "./VetBackground.vue?vue&type=style&index=0&id=649a4ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a4ef2",
  null
  
)

export default component.exports